import { Injectable } from '@angular/core';
import { NewQuote } from '../../models/search/new-quote';
import { SearchQuote } from '../../models/search/search-quote';
import { SearchList } from '../../models/search/search-list';
import { QuotationStatusDTO } from '../../models/search/quotation-status-dto';
import { VehicleBrandDTO } from '../../models/search/vehicle-brand-dto';
import { VehicleModelDTO } from '../../models/search/vehicle-model-dto';
import { VehicleVariantDTO } from '../../models/search/vehicle-variant-dto';
import { QuotationEntityIdDto } from '../../models/search/quotation-entity-id-dto';
import { VehicleBrandUsedDTO } from 'src/app/models/search/vehicle-brand-used-dto';
import { VehicleModelUsedDTO } from 'src/app/models/search/vehicle-model-used-dto';
import { NewOrUsed } from 'src/app/models/search/newORused';
import { TrackResult } from 'src/app/models/track/trackResult';
import { ApprovalStatusList } from 'src/app/models/approvalStatusList';
import { ApprovalListTable } from 'src/app/models/approvalListTable';
import { DocRespDto } from 'src/app/models/track/doc-resp-dto';
import { DocViewDto } from 'src/app/models/track/doc-view-dto';

@Injectable({
  providedIn: 'root'
})
export class QuoteRenderingService {

  _newQuote: NewQuote;
  _newOrUsed: NewOrUsed;
  _searchQuote: SearchQuote;
  _docViewDto: DocViewDto;
  _quotation: QuotationEntityIdDto;
  searchList: SearchList[];
  quotationStatus: QuotationStatusDTO[];
  brands: VehicleBrandDTO[];
  usedBrands: VehicleBrandUsedDTO[];
  models: VehicleModelDTO[];
  usedModels: VehicleModelUsedDTO[] = [];
  variants: VehicleVariantDTO[];
  _checkModifyButton: boolean;
  _track: TrackResult; // trackResult
  docList: DocRespDto[];


  constructor() {
    this._newQuote = new NewQuote();
    this._newOrUsed = new NewOrUsed();
    this._searchQuote = new SearchQuote();
    this._quotation = new QuotationEntityIdDto();
    this._docViewDto = new DocViewDto();
    this.searchList = [];
    this.docList = [];
    this.quotationStatus = [];
    this.brands = [];
    this.models = [];
    this.variants = [];
    this.usedBrands = [];
    this.usedModels = [];
    this.trackResult = new TrackResult();
    this.checkModifyButton = false;

  }

  public get newQuote(): NewQuote {
    return this._newQuote;
  }

  public set newQuote(value: NewQuote) {
    this._newQuote = value;
  }

  public get docViewDto(): DocViewDto {
    return this._docViewDto;
  }

  public set docViewDto(value: DocViewDto) {
    this._docViewDto = value;
  }

  public get newOrUsed(): NewOrUsed {
    return this._newOrUsed;
  }

  public set newOrUsed(value: NewOrUsed) {
    this._newOrUsed = value;
  }

  public get searchQuote(): SearchQuote {
    return this._searchQuote;
  }

  public set searchQuote(value: SearchQuote) {
    this._searchQuote = value;
  }

  public get quotation(): QuotationEntityIdDto {
    return this._quotation;
  }

  public set quotation(value: QuotationEntityIdDto) {
    this._quotation = value;
  }

  public get trackResult(): TrackResult {
    return this._track;
  }

  public set trackResult(value: TrackResult) {
    this._track = value;
  }

  public get checkModifyButton(): boolean {
    return this._checkModifyButton;
  }

  public set checkModifyButton(value: boolean) {
    this._checkModifyButton = value;
  }

}
